import { useQuery } from '@tanstack/react-query';
import { functions } from '../../../firebase';
import { useAppSelector } from '../../../hooks';
import { useParams } from 'react-router';
import { z } from 'zod';

const overviewResponseSchema = z.array(z.object({ day: z.object({ value: z.string() }) }));

export const useGpsOverview = (month: string, enabled: boolean) => {
  const { orgId } = useParams<{ orgId: string }>();
  const gpsId = useAppSelector((state) => state.sensors.currentSensor.identifier);
  const { data, isFetching, isPending, error, refetch } = useQuery({
    queryKey: ['gpsOverview', orgId, gpsId, month],
    queryFn: async () => {
      const functionRef = functions.httpsCallable('settings');
      const response = await functionRef({
        requestType: 'GET_GPS_OVERVIEW',
        gpsId,
        orgId,
        month,
      });

      const errorCode = response?.data?.httpErrorCode?.status;
      if (errorCode) {
        throw new Error(`Error fetching GPS overview: ${errorCode}`);
      }
      return overviewResponseSchema.parse(response.data).map((item) => item.day.value);
    },
    enabled: enabled && !!orgId && !!gpsId,
    // Refresh each time the calendar opens so its movement markers track the live day view.
    staleTime: 0,
    retry: false,
  });

  return { data, isFetching, isPending, error, refetch };
};
